import React from "react";
import { Box, Typography, Avatar, IconButton } from "@mui/material";
import { LinkedIn, Email } from "@mui/icons-material";
import PropTypes from "prop-types";
import teamMemberStyle from "./teamMemberStyle";

// TeamMember component to display individual team member information
const TeamMember = ({ member }) => {
  const classes = teamMemberStyle();

  return (
    <Box className={classes.teamMember}>

      {/* Avatar */}
      <Avatar alt={member.name} src={member.img} className={classes.avatar} />

      {/* Name */}
      <Typography variant="h7" className={classes.name}>
        {member.name}
      </Typography>

      {/* Role */}
      <Typography variant="subtitle2" className={classes.role}>
        {member.role}
      </Typography>

      {/* Description */}
      <Typography variant="body2" className={classes.description}>
        {member.description}
      </Typography>

      {/* Social Icons */}
      <Box className={classes.socialIcons}>
        <IconButton href={member.linkedin} target="_blank" className={classes.icon}>
          <LinkedIn />
        </IconButton>
        <IconButton href={`mailto:${member.email}`} className={classes.icon}>
          <Email />
        </IconButton>
      </Box>
    </Box>
  );
};

TeamMember.propTypes = {
    member: PropTypes.shape({
      name: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired,
      description: PropTypes.node.isRequired,
      linkedin: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }).isRequired,
  };

  export default TeamMember;